<template>
  <div class="remarks-main">
    <div class="top-bar">
      <span v-if="isRequired" style="color: red; margin-right: 5px">**</span>
      <div class="title">{{ title }}</div>
      <div class="max-char">
        <span v-if="!freeText">Max.</span>
        <span v-if="currentLength > 0 || freeText" :style="{ color: currentLength > maxLength && !freeText ? 'red' : 'unset' }">{{ currentLength }}</span>
        <span v-if="currentLength > 0 && !freeText"> /</span>
        <span v-if="!freeText">{{ maxLength }}</span> char
      </div>
    </div>
    <div class="textarea-container">
      <textarea
        :style="{ backgroundColor: isDisabled ? 'rgba(200,200,200,0.3)' : currentLength > maxLength && !freeText ? 'rgba(255,0,0,0.3)' : 'unset' }"
        :disabled="isDisabled" @input="textChanged" @focus="textareaFocused" v-model="pText"
        ref="textArea"
      >
      </textarea>
      <div v-if="errorMessage" class="error-message">
        {{errorMessage}}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  computed: {
    currentLength: function() {
      return this.pText.length;
    },
  },
  data: function() {
    return {
      pText: ''
    }
  },
  props: {
    // Public properties
    title: { type: String, default: 'Remarks' }, // The title of the remarks box
    text: { type: String, default: '' }, // The text of the textarea (Use .sync for 2 way binding)
    maxLength: { type: Number, default: 100 }, // The maximum number of characters accepted in the textarea
    isDisabled: { type: Boolean, default: false }, // Set this to true to disable any user input
    isRequired: { type: Boolean, default: false }, // Set this to true to indicate this input is required
    freeText: { type: Boolean, default: false },
    errorMessage: { type: String, default: '' }, // Set an error message (BETA)
  },
  methods: {
    textChanged: function(e) {
      if (this.pText.trim() === "") { // disallow whitespace without any characters
        this.pText = "";
      }

      if (!this.freeText && this.pText.length > this.maxLength) { // prevent input that exceeds max length set
        const selectionStart = this.$refs.textArea.selectionStart;
        const selectionEnd = this.$refs.textArea.selectionEnd;
        const charactersDifference = this.pText.length - this.text.length; // new value length - old value length

        this.pText = this.text; // revert to previous value
        this.$nextTick(() => { // reset cursor to previous position
          this.$refs.textArea.setSelectionRange(selectionStart - charactersDifference, selectionEnd - charactersDifference);
        });
      }

      this.$emit('update:text', this.pText);
    },
    textareaFocused: function(focusEvent) {
      this.$emit("update:errorMessage", ""); // clear off errorMessage on text area focus
    },
    setFocus: function() {
      this.$refs["textArea"].focus();
    },
  },
  mounted() {
    if (this.text) {
      this.pText = this.text;
    }
  },
  watch: {
    text: function(val) {
      this.pText = val;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.remarks-main {
  font-size: 12px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 3px 0;
}

.textarea-container {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  > .error-message {
    position: absolute;
    top: 3px;
    left: 3px;
    border-radius: 5px;
    padding: 1px 5px;
    background-color: red;
    color: white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    pointer-events: none;
  }
}

textarea {
  height: 100%;
  width: 100%;
  resize: none;
  overflow-y: auto;
  border: 1px solid rgb(200,200,200);
  border-radius: 3px;

  &:hover ~ .error-message {
    border: 1px solid black;
    overflow: visible;
    z-index: 111;
  }
}

textarea:focus {
  outline: none;
}

textarea:disabled {
  opacity: 0.8;
  background: rgba(200,200,200,0.3);
}

.top-bar {
  display: flex;
  width: 100%;

  .title {
    flex-grow: 1;
    text-align: left;
  }
}
</style>